import { ArrowRight } from '@/components/icons';
import { Card } from '@/components/ui/card';

interface QuickStartCardProps {
  onClick: () => void;
}

export function QuickStartCard({ onClick }: QuickStartCardProps) {
  return (
    <Card
      role="button"
      tabIndex={0}
      onClick={onClick}
      className="flex items-center justify-between gap-4 w-full text-left hover:bg-background-brand-subtle transition-colors cursor-pointer"
    >
      <div className="flex flex-col gap-1 min-w-0">
        <p className="text-xs font-semibold text-content-brand-bold opacity-70 leading-4">
          Continue Setup
        </p>
        <p className="text-base font-semibold text-content-primary-bold leading-6 tracking-[-0.5px]">
          Get your operation ready
        </p>
      </div>
      <div className="bg-background-brand-bold text-content-primary-white rounded-full h-8 px-3 flex items-center gap-1.5 shrink-0">
        <span className="text-xs font-semibold leading-4">Continue</span>
        <ArrowRight className="size-3" />
      </div>
    </Card>
  );
}
